import { createStructuredSelector } from 'reselect';
import {
  DP_LIST, DP_LIST_SUCCESS, DP_LIST_ERROR, DP_PAGE_SET,
  DP_UPDATE, DP_UPDATE_SUCCESS, DP_UPDATE_ERROR,
  DP_FILTER_SUPPLIERS, DP_FILTER_SUPPLIERS_SUCCESS,
  DP_FILTER_ACQUISITION_DETAILS, DP_FILTER_ACQUISITION_DETAILS_SUCCESS,
  DP_FILTER_DESTINATIONS, DP_FILTER_DESTINATIONS_SUCCESS,
  DP_FILTER_DISBURSEMENTS, DP_FILTER_DISBURSEMENTS_SUCCESS,
  DP_SEARCH_CHANGE,
  DELIVERY_PLAN_TASK_UPDATE, DELIVERY_PLAN_TASK_UPDATE_SUCCESS, DELIVERY_PLAN_TASK_UPDATE_ERROR
} from '../../actions';

export const NAME = 'delivery_plan';

export const DeliveryPlanList = (page, num_page, orderBy, filters) => ({ type: DP_LIST, payload: { page, num_page, orderBy, filters } });
export const DeliveryPlanListSuccess = (data) => ({ type: DP_LIST_SUCCESS, payload: data });
export const DeliveryPlanListError = (error) => ({ type: DP_LIST_ERROR, payload: error });
export const DpPageSet = (data) => ({ type: DP_PAGE_SET, payload: data });
export const DeliveryPlanUpdate = (data) => ({ type: DP_UPDATE, payload: data });
export const DeliveryPlanUpdateSuccess = (message) => ({ type: DP_UPDATE_SUCCESS, payload: message });
export const DeliveryPlanUpdateError = (error) => ({ type: DP_UPDATE_ERROR, payload: error });

export const DeliveryPlanFilterSuppliers = () => ({ type: DP_FILTER_SUPPLIERS });
export const DeliveryPlanFilterSuppliersSuccess = (data) => ({ type: DP_FILTER_SUPPLIERS_SUCCESS, payload: data });
export const DeliveryPlanFilterAcquisitionDetails = () => ({ type: DP_FILTER_ACQUISITION_DETAILS });
export const DeliveryPlanFilterAcquisitionDetailsSuccess = (data) => ({ type: DP_FILTER_ACQUISITION_DETAILS_SUCCESS, payload: data });
export const DeliveryPlanFilterDestinations = () => ({ type: DP_FILTER_DESTINATIONS });
export const DeliveryPlanFilterDestinationsSuccess = (data) => ({ type: DP_FILTER_DESTINATIONS_SUCCESS, payload: data });
export const DeliveryPlanFilterDisbursements = () => ({ type: DP_FILTER_DISBURSEMENTS });
export const DeliveryPlanFilterDisbursementsSuccess = (data) => ({ type: DP_FILTER_DISBURSEMENTS_SUCCESS, payload: data });
export const DeliveryPlanSearchChange = (data) => ({ type: DP_SEARCH_CHANGE, payload: data });

export const DeliveryPlanTaskUpdate = (data) => ({ type: DELIVERY_PLAN_TASK_UPDATE, payload: data });
export const DeliveryPlanTaskUpdateSuccess = (message) => ({ type: DELIVERY_PLAN_TASK_UPDATE_SUCCESS, payload: message });
export const DeliveryPlanTaskUpdateError = (error) => ({ type: DELIVERY_PLAN_TASK_UPDATE_ERROR, payload: error });

const delivery_plan = (state) => state[NAME];
export const DeliveryPlanSelector = createStructuredSelector({ delivery_plan });
